import styled from "styled-components"
import { transparentize } from "polished"

const StyledContainer = styled.div`
  width: auto;
  height: 5.8rem;
  display: flex;
  box-shadow: 0 0.2rem 0.4rem 0
    ${({ theme }) => transparentize(0.88, theme.color.main01)};
  background: ${({ theme }) => theme.color.white};
  transform: translate(-2.8rem, -4.8rem);
  position: absolute;
  padding: 1.2rem;
`
const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.2rem;
`
const StyledFirstLine = styled.div`
  display: flex;
  align-items: center;
`

const StyledIcon = styled.img`
  height: 3.2rem;
  width: 2.4rem;
`
const StyledName = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.secondary01};
  white-space: nowrap;
`

const StyledTime = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.quinary03};
  margin-left: 0.4rem;
  white-space: nowrap;
`
const StyledTraffic = styled.span`
  font-style: italic;
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: 1rem;
  line-height: 1.67;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.color.secondary02};
`

export {
  StyledContainer,
  StyledContentContainer,
  StyledIcon,
  StyledName,
  StyledTime,
  StyledTraffic,
  StyledFirstLine,
}
